export const checkboxStyles = {
  '& .checkbox': {
    gap: '9px',
  },
};

export const hiddenFieldStyles = {
  '& .checkbox, & .helper-text': {
    display: 'none !important',
  },
};
